<script lang="ts" setup>
import { ExportDocumentFormat } from "~/types/enums/ExportDocumentFormat.enum";

// define props with an array of ExportDocumentFormat which is an enum with the default being [ExportDocumentFormat.docx, ExportDocumentFormat.pdf]
const documentId = inject("documentId") as any;

const props = defineProps({
  formats: {
    type: Array as PropType<ExportDocumentFormat[]>,
    default: () => [ExportDocumentFormat.docx, ExportDocumentFormat.pdf],
  },
  color: {
    type: String,
    default: "primary",
  },
  variant: {
    type: String as PropType<"outlined" | "text">,
    default: "outlined",
  },
});

const showExportWordButton = computed(() => {
  return (
    props.formats.length == 1 &&
    props.formats.includes(ExportDocumentFormat.docx)
  );
});

const showExportPDFButton = computed(() => {
  return (
    props.formats.length == 1 &&
    props.formats.includes(ExportDocumentFormat.pdf)
  );
});

const submittedDocumentStore = useSubmittedDocumentStore(documentId);
const { hasContacts, student, submittedDocument, revision } = storeToRefs(
  submittedDocumentStore
);

const isSupportedExportType = computed(() => {
  // Unsupported Types
  const unsupportedTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ];

  return (
    unsupportedTypes.includes(revision.value?.fileObject?.mimeType ?? "") !=
    true
  );
});
</script>

<template>
  <div v-if="isSupportedExportType">
    <BasePopover v-if="formats.length > 1">
      <BaseOutlinedButton v-if="variant === 'outlined'" :color="color">
        <div class="flex flex-row items-center">
          <BaseIconCloudDownload class="mr-1" />
          <span> Export </span>
        </div>
      </BaseOutlinedButton>
      <BaseTextButton v-else :color="color">
        <div class="flex flex-row items-center">
          <BaseIconCloudDownload class="mr-1" />
          <span> Export </span>
        </div>
      </BaseTextButton>
      <template #content>
        <div class="flex flex-col w-[200px] p-1">
          <ExportDocumentWordButton
            v-if="formats.includes(ExportDocumentFormat.docx)"
            v-close-popper
            class="w-full"
          />
          <ExportDocumentPDFButton
            v-if="formats.includes(ExportDocumentFormat.pdf)"
            v-close-popper
            class="w-full"
          />
          <ExportDocumentCopyClipboard
            v-if="formats.includes(ExportDocumentFormat.clipboard)"
            v-close-popper
            class="w-full"
          />
        </div>
      </template>
    </BasePopover>
    <ExportDocumentWordButton
      v-if="showExportWordButton"
      :variant="variant"
      :color="color"
    />
    <ExportDocumentPDFButton
      v-if="showExportPDFButton"
      :variant="variant"
      :color="color"
    />
  </div>
</template>

<style scoped></style>
